import { connect } from 'react-redux'
import { profilesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import PropTypes from 'prop-types'
import React, { Fragment, Component } from 'react'
import Typography from '@material-ui/core/Typography'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import PermissionsTable from '../../components/PermissionsTable'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = profile => {
    const { onClose, addProfile, editProfile, changeMessage } = this.props

    if (profile._id) {
      editProfile(profile).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addProfile(profile).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, profile) => {
    e.preventDefault()
    const { setProfileFormTouched } = this.props

    if (this.props.profileFormErrors.valid) {
      this.handleSave(profile)
    } else {
      setProfileFormTouched()
    }

    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  filteredFunctionalities = regex => {
    const { functionalities = [] } = this.props
    return functionalities.filter(item => regex.test(item.alias))
  }

  onChange = (functionality, type) => event => {
    const { handlePermissionsChange } = this.props
    const { checked } = event.target

    handlePermissionsChange({ functionality, type, checked })
  }

  render() {
    const {
      classes,
      formTouched,
      fullScreen,
      handleChangeProfile,
      loadingProfile,
      onClose,
      open = false,
      profile,
      profileFormErrors,
      token
    } = this.props

    const { clearErrors, handleSubmit, filteredFunctionalities, onChange } = this

    const isReadOnly = readOnly('perfis', token)

    const permissionTables = [
      { title: 'Conteudos', regex: /conteudos-/ },
      { title: 'Pré-cadastros', regex: /preCadastros-/ },
      { title: 'Outros', regex: /^(?!conteudos|preCadastros).*/ }
    ]

    return (
      <div>
        <Dialog
          modalId={profile._id ? 'perfis-editar' : 'perfis-novo'}
          modalParams={{ registro: profile._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingProfile ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(profile._id ? 'perfis-editar' : 'perfis-novo') + '-title'}>
                {isReadOnly ? (
                  'Perfil'
                ) : (
                  <Fragment>{profile._id ? 'Editar perfil' : 'Cadastrar perfil'}</Fragment>
                )}
              </DialogTitle>
              <DialogContent>
                <form
                  id={'profile-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, profile)
                  }}
                >
                  <FormControl
                    error={!((profileFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={true}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeProfile({ ...profile, nome: e.target.value })
                      }}
                      value={profile.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((profileFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((profileFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  {permissionTables.map(item => {
                    return (
                      <PermissionsTable
                        readOnly={isReadOnly}
                        sectionTitle={item.title}
                        permissions={profile.permissoes}
                        functionalities={filteredFunctionalities(item.regex)}
                        onChange={onChange}
                      />
                    )
                  })}
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'profile-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    formTouched: state.profiles.profileFormTouched,
    functionalities: state.profiles.functionalities,
    loadingProfile: state.profiles.loadingProfile,
    profile: state.profiles.profile,
    profileFormErrors: state.profiles.profileFormErrors,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(profilesActions.openModal())
    },
    closeModal: () => {
      dispatch(profilesActions.closeModal())
    },
    handleChangeProfile: profile => {
      dispatch(profilesActions.handleChangeProfile(profile))
    },
    addProfile: profile => {
      return dispatch(profilesActions.addProfile(profile))
    },
    editProfile: profile => {
      return dispatch(profilesActions.editProfile(profile))
    },
    setProfileFormTouched: profile => {
      dispatch(profilesActions.setProfileFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handlePermissionsChange: permission => {
      dispatch(profilesActions.handlePermissionsChange(permission))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Profiles/EditModal.js